import styled from "@emotion/styled";

export type StepperItemState = "completed" | "current" | "upcoming";

const StepperWrapper = styled.ol`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.space16};
  margin: 0;
  padding-block: ${({ theme }) => theme.space.space16};
  list-style: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: ${({ theme }) => theme.space.space24};
    padding-block: ${({ theme }) => theme.space.space24};
  }
`;

const StepperItemWrapper = styled.li<{ $state: StepperItemState }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.space4};
  color: ${({ theme, $state }) =>
    $state === "current"
      ? theme.colors.tone.black
      : theme.colors.tone.anthraciteLight};
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: 400;
  line-height: 20px;
  white-space: nowrap;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.fontSizes.fontSize16};
    line-height: 24px;
  }
`;

const StepperBadge = styled.span<{ $state: StepperItemState }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ theme, $state }) =>
    $state === "upcoming"
      ? theme.colors.tone.silver
      : theme.colors.semantic.green};
  color: ${({ theme }) => theme.colors.tone.white};
  font-size: ${({ theme }) => theme.fontSizes.fontSize16};
  font-weight: 600;
  line-height: 20px;
`;

const StepperSeparator = styled.li`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.tone.silver};
  }
`;

export { StepperWrapper, StepperItemWrapper, StepperBadge, StepperSeparator };
